module.exports = __webpack_public_path__ + "static/elephantcloudmain-8c57c32702368a770fa6cfb955c92d58.png";